const Farm = {

    // FIELDS
    "room": "Room",
    "crop": "Crop",
    "schedule_variant_id": "Variant",
    "start_date": "Start Date",
    "search": "Search",
    "filter_status": "Status",
    "status_all": "All",
    "status_active": "Active",
    "status_inactive": "Inactive",
    "status_completed": "Completed",

    // PAGE HEADER
    "farm": "Farm",

    // TOAST

    // TOOLTIP
    "add_crop": "Add Crop",
    "view_schedule": "View Schedule",
    "work_status": "Status",
    "schedule_status": "Schedule Status",
    "scheduled_date": "Scheduled Date",
    "done": "DONE",
    "not_done": "NOT DONE",
    "crop_cycle_complete": "Crop Cycle Complete",
    "confirm_crop_cycle_complete_title": "Complete crop cycle?",
    "confirm_crop_cycle_complete_text": "Are you sure you want to mark this crop cycle as complete?",
    "crop_cycle_complete_success": "Crop cycle ended successfully",
    "reason": "Reason",
    "photos": "Photos",
    "error_reason": "Enter Reason",

    // EMPTY
    "no_crop": "No Crops Found",
    "no_schedule": "No Schedule Found",

    // ERROR
    "error_room": "Select Room",
    "error_crop": "Select Crop",
    "error_schedule_variant_id": "Select Variant",
    "error_start_date": "Choose Start Date",

    // TABLE HEADER
    "table_farm": 'FARM',
    "table_crop": 'CROP',
    "table_nature": 'NATURE',
    "table_structure": "STRUCTURE",
    "table_name": "NAME",
    "table_mobile": "MOBILE",
    "table_tehsil": "TEHSIL",
    "table_status": "STATUS",

}

export default Farm;